import { useFeedbackAlertCallbacks } from 'modules/common/hooks/useFeedbackAlertCallbacks'
import { useTranslation } from 'modules/common/hooks/useTranslation'
import { trackEvent } from 'modules/common/lib/amplitude/trackEvent'
import { useCallback } from 'react'
import { EnumAuthTrackingEvents } from '../lib/tracking/events'
import { usePostVerificationEmailMutation } from '../mutations/usePostVerificationEmailMutation'
import { useAuthenticatedUserQuery } from '../queries/useAuthenticatedUserQuery'

export const useSendVerificationEmailFlow = () => {
  const { t } = useTranslation('auth-components')

  const { showErrorFeedbackAlert, showSuccessFeedbackAlert } =
    useFeedbackAlertCallbacks({
      errorDescription: t('emailVerification.alert.sendEmailError'),
      successDescription: t('emailVerification.alert.sendEmailSuccess'),
    })

  const { mutate: sendVerificationEmail, isPending } =
    usePostVerificationEmailMutation({
      mutationOptions: {
        onError: showErrorFeedbackAlert,
        onSuccess: showSuccessFeedbackAlert,
      },
    })

  const { data: user } = useAuthenticatedUserQuery(
    {
      refetchInterval: 5000,
    },
    { force: true }
  )

  const resendEmail = useCallback(() => {
    trackEvent({
      eventType: EnumAuthTrackingEvents.SIGNUP_RESEND_CONFIRMATION_EMAIL,
    })
    sendVerificationEmail()
  }, [sendVerificationEmail])

  return { resendEmail, isLoading: isPending, user }
}
